import { render } from "./ProposalView.vue?vue&type=template&id=b8b15aa8&scoped=true"
import script from "./ProposalView.vue?vue&type=script&lang=js"
export * from "./ProposalView.vue?vue&type=script&lang=js"

import "./ProposalView.vue?vue&type=style&index=0&id=b8b15aa8&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8b15aa8"]])

export default __exports__